<template>
  <div class="error-404 bg-img">
    <div class="error-404__content">
      <img src="@/assets/images/pages/404.png"  alt="graphic-404" class="mx-auto mb-4 max-w-100">
      <h1 class="sm:mx-0 mx-4 mb-12 text-5xl d-theme-heading-color">404 - Página não encontrada!</h1>
      <p >A página solicitada não pôde ser encontrada.</p>
      <vs-button class="error-404__content-button" @click="handleRedirectHome">Voltar para home</vs-button>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'error404',

  methods: {
    handleRedirectHome() {
      window.location.href = 'https://www.filoo.com.br/'
    }
  }
})
</script>

<style lang="scss" scoped>
.error-404 {
  align-items: center;
  display: flex;
  height: 99.9vh;
  justify-content: center;
  width: 99.9vw;

  &__content {
    align-items: center;
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 1rem;
    text-align: center;

    h1 {
      margin: 1rem 0 .5rem;
    }

    &-button {
      display: flex;
      margin: 2rem auto 0;
    }
  }
}
</style>